// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel_Carousel__W61SU","list":"Carousel_list__qPEFy","CarouselItem":"Carousel_CarouselItem__EIq5D"};